import { useApiContext } from '@customink/project-service-react-components';

import { useAuth } from '@/contexts/auth/AuthContext';

export const useCreateOrGetEcommerceToken = () => {
  const api = useApiContext();
  const { personalAccount } = useAuth();

  return api.useCreateOrGetEcommerceTokenQuery(
    { accountId: personalAccount?.id as string },
    { skip: !personalAccount?.id },
  );
};
